import 'core-js';
import React from 'react'
import { render } from 'react-dom'
import {connect, Provider} from 'react-redux'
import { Route } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { history } from './store'
import Home from './containers/home'
import 'sanitize.css/sanitize.css'
import './styles/main.scss'
import Header from './components/header'
import Challenges from "./containers/challenges";
import Challenge from "./containers/challenge";
import {bindActionCreators} from "redux";
import HallOfFame from "./containers/hall-of-fame";
import Example from "./containers/example";
import AboutModal from "./components/about-modal";
import RulesModal from "./components/rules-modal";
import Activate from "./containers/activate";
import { PersistGate } from 'redux-persist/integration/react'
import configureStore from './store';

import LinkedInTag from 'react-linkedin-insight';

LinkedInTag.init('34541');

const { persistor, store } = configureStore();
const target = document.querySelector('#root')

function mapStateToProps(state) {
	return {auth: state.auth};
}

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

let App = (props) => (
	<div className="container min-1400">
		<Header {...props} />

		<AboutModal {...props} />
		<RulesModal {...props} />

		{!props.auth.token && <Route exact path={'/'} component={Home} />}
		{props.auth.token && <Route exact path={'/'} component={Challenges} />}
		<Route path={'/challenges/:challenge_id'} component={Challenge} />
		<Route path={'/halloffame'} component={HallOfFame} />
		<Route path={'/example'} component={Example} />
		<Route path={'/activation'} component={Activate} />

		<footer>
			<p>For inquiries and feedback please email us at: <a href={"mailto:irchallenge@cynet.com"}>irchallenge@cynet.com</a>.</p>
		</footer>
	</div>
)

App = connect(
	mapStateToProps,
	mapDispatchToProps
)(App);

render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<ConnectedRouter history={history}>
				<App />
			</ConnectedRouter>
		</PersistGate>
	</Provider>,
	target
)
